var fields = {
    email: '',
    message: '',
    name: '',
    terms: '',
    subject: ''
}

function validate() {
    var emailTag = document.getElementById("Email");
    var nameTag = document.getElementById("Name");
    var subjectTag = document.getElementById("Subject");
    var messageTag = document.getElementById("Message");
    var termsTag = document.getElementById("Terms");

    var validTerms = false;
    var validEmail = false;
    var validName = false;
    var validSubject = false;
    var validMessage = false;

    if (termsTag) {
        validTerms = validateTerms(termsTag);
    }

    if (emailTag) {
        if (emailTag.hasAttribute('required')) {
            validEmail = validateEmail(emailTag, emailTag.value);
        } else {
            validEmail = true;
        }
    }

    if (nameTag) {
        if (nameTag.hasAttribute('required')) {
            validName = validateString(nameTag, nameTag.value);
        } else {
            validName = true;
        }
    }

    if (subjectTag) {
        if (subjectTag.hasAttribute('required')) {
            validSubject = validateString(subjectTag, subjectTag.value);
        } else {
            validSubject = true;
        }
    }

    if (messageTag) {
        if (messageTag.hasAttribute('required')) {
            validMessage = validateString(messageTag, messageTag.value);
        } else {
            validMessage = true;
        }
    }

    return validTerms && validEmail && validName && validSubject && validMessage;
}

function submitContactForm(target) {
    var errorTag = target.previousElementSibling;
    var valid = validate();

    if (errorTag) {
        errorTag.style.display = "none";
    }
    
    var emailTag = document.getElementById("Email");
    var nameTag = document.getElementById("Name");
    var subjectTag = document.getElementById("Subject");
    var messageTag = document.getElementById("Message");
    var termsTag = document.getElementById("Terms");
    var recieverTag = document.getElementById("Reciever");
    var thankYouTag = document.getElementById("ThankYouMessage");
    var ratingTag = document.getElementById("Rating");
    var isFeedbackForm = document.getElementById('IsFeedbackForm');

    if (valid) {
        if (isFeedbackForm) {
            axios.post('/umbraco/surface/ContactForm/Submit', {
                Name: nameTag.value,
                Email: emailTag.value,
                Subject: subjectTag.value,
                Message: messageTag.value,
                Terms: termsTag.checked,
                Reciever: recieverTag.value,
                ThankYouMessage: thankYouTag.value,
                Rating: parseInt(ratingTag.value),
                IsFeedbackForm: isFeedbackForm.value == 'true'
            },
                { headers: { 'Content-Type': 'application/json' } }
            ).then(function (response) {
                if (response.data.errorMessage) {
                    errorTag.style.display = "block";
                    errorTag.innerText = response.data.errorMessage;
                } else if (response.data.thankYouMessage) {
                    var formTag = document.getElementById("contact-form");
                    target.style.display = "none";
                    formTag.innerHTML = response.data.thankYouMessage;
                }
            }).catch((error) => {
                console.log(error);
            })
        } else {
            axios.post('/umbraco/surface/ContactForm/Submit', {
                Name: nameTag.value,
                Email: emailTag.value,
                Subject: subjectTag.value,
                Message: messageTag.value,
                Terms: termsTag.checked,
                Reciever: recieverTag.value,
                ThankYouMessage: thankYouTag.value
            },
                { headers: { 'Content-Type': 'application/json' } }
            ).then(function (response) {
                if (response.data.errorMessage) {
                    errorTag.style.display = "block";
                    errorTag.innerText = response.data.errorMessage;
                } else if (response.data.thankYouMessage) {
                    var formTag = document.getElementById("contact-form");
                    target.style.display = "none";
                    formTag.innerHTML = response.data.thankYouMessage;
                }
            })
        }
    }
}

function validateEmail(el, input) {
    var valid = /(.+)@(.+){2,}\.(.+){2,}/.test(input)

    if (!valid) {
        if (!el.classList.contains('error')) {
            el.classList.add('error')
        }
        if (el.nextElementSibling.classList.contains('hide')) {
            el.nextElementSibling.classList.remove('hide');
        }
    } else {
        if (el.classList.contains('error')) {
            el.classList.remove('error')
        }
        if (!el.nextElementSibling.classList.contains('hide')) {
            el.nextElementSibling.classList.add('hide');
        }
    }
    return valid;
}

function validateTerms(el) {
    if (!el.checked) {
        el.parentElement.lastElementChild.classList.remove('hide');
        el.parentElement.lastElementChild.innerText = "Du måste godkänna villkoren";
    } else {
        el.parentElement.lastElementChild.classList.add('hide');
    }
    return el.checked;
}

function validatePhone(el, input) {
    var re = /^(1[ \-\+]{0,3}|\+1[ -\+]{0,3}|\+1|\+)?((\(\+?1-[2-9][0-9]{1,2}\))|(\(\+?[2-8][0-9][0-9]\))|(\(\+?[1-9][0-9]\))|(\(\+?[17]\))|(\([2-9][2-9]\))|([ \-\.]{0,3}[0-9]{2,4}))?([ \-\.][0-9])?([ \-\.]{0,3}[0-9]{2,4}){2,3}$/;
    return re.test(input);
}

function validateString(el, input) {
    var valid = input.length > 1;

    if (!valid) {
        if (!el.classList.contains('error')) {
            el.classList.add('error')
        }
        if (el.nextElementSibling.classList.contains('hide')) {
            el.nextElementSibling.classList.remove('hide');
        }
    } else {
        if (el.classList.contains('error')) {
            el.classList.remove('error')
        }
        if (!el.nextElementSibling.classList.contains('hide')) {
            el.nextElementSibling.classList.add('hide');
        }
    }
    return valid;
}


window.validateString = validateString;
window.validateEmail = validateEmail;
window.validateTerms = validateTerms;

/**
 * Submits a form builder form via AJAX
 * @param {HTMLFormElement} form - The form element to submit
 * @param {string} formId - The form ID
 */
function submitFormBuilderForm(form, formId) {
    const successMessageEl = document.getElementById(`success-message-${formId}`);
    const errorMessageEl = document.getElementById(`error-message-${formId}`);
    const errorTextEl = document.getElementById(`error-text-${formId}`);

    // Validate HTML5 form
    if (!form.checkValidity()) {
        form.reportValidity();
        return;
    }

    // Create FormData from the form
    const formData = new FormData(form);

    // Submit via AJAX
    fetch(form.action || '/umbraco/surface/ContactForm/HandleForm', {
        method: 'POST',
        body: formData,
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    })
    .then(response => {
        // Check if response is JSON
        const contentType = response.headers.get('content-type');
        if (!contentType || !contentType.includes('application/json')) {
            console.error('Expected JSON response but got:', contentType);
            console.error('Response status:', response.status);
            throw new Error('Server did not return JSON. Status: ' + response.status);
        }
        return response.json();
    })
    .then(data => {
        // Hide both messages first
        if (successMessageEl) successMessageEl.style.display = 'none';
        if (errorMessageEl) errorMessageEl.style.display = 'none';

        if (data.success) {
            // Show success message
            if (successMessageEl) {
                successMessageEl.style.display = 'block';
                // Scroll to message
                successMessageEl.scrollIntoView({ behavior: 'smooth', block: 'end' });
                // Optionally reset the form
                form.reset();
            }
        } else {
            // Show error message
            if (errorMessageEl) {
                if (errorTextEl) {
                    errorTextEl.textContent = data.errorMessage || 'An error occurred while submitting the form.';
                }
                errorMessageEl.style.display = 'block';
                // Scroll to error message
                errorMessageEl.scrollIntoView({ behavior: 'smooth', block: 'end' });
            }
        }
    })
    .catch(error => {
        console.error('Form submission error:', error);
        if (errorMessageEl) {
            if (errorTextEl) {
                errorTextEl.textContent = 'An unexpected error occurred. Please try again.';
            }
            errorMessageEl.style.display = 'block';
            errorMessageEl.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
    });
}

window.submitFormBuilderForm = submitFormBuilderForm;

window.submitContactForm = submitContactForm;